module.exports = __webpack_public_path__ + "img/flit2goLogoWhite.4f540b6d.svg";